import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {PageViewModel} from '@components/ui/table-template/models/page-view-model';
import {EntityInvestmentViewModel} from '../view-models/entity-investment.view-model';

import {EntityInvestmentCardComponent} from '../entity-investment-card/entity-investment-card.component';

@Component({
    selector: 'app-entity-investment-card-container',
    templateUrl: './entity-investment-card-container.component.html',
    styleUrls: ['./entity-investment-card-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EntityInvestmentCardComponent]
})
export class EntityInvestmentCardContainerComponent {

  public readonly currentPage = input.required<PageViewModel<EntityInvestmentViewModel>>();

  public readonly cardClicked = output<EntityInvestmentViewModel>();

  handleCardClicked(entityInvestmentVM: EntityInvestmentViewModel): void {
    this.cardClicked.emit(entityInvestmentVM);
  }
}
